import { render } from "./NavigationMenu.vue?vue&type=template&id=fa20fbe6&scoped=true"
import script from "./NavigationMenu.vue?vue&type=script&lang=js"
export * from "./NavigationMenu.vue?vue&type=script&lang=js"

import "./NavigationMenu.vue?vue&type=style&index=0&id=fa20fbe6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa20fbe6"]])

export default __exports__